export default {
    // Auth
    POST_AUTH: '/auth/authenticate',

    // Bug Report
    GET_BUG_REPORT: `/bugreport`,

    // Indexes
    GET_INFLATION_INDEXES: '/indexes/inflation',

    // Misc
    GET_COUNTRIES: '/misc/countries',
    GET_INDUSTRIES: '/misc/industries',

    // Rates
    GET_EXCHANGE_RATES: `/rates/exchange-rates`,
    GET_MARKET_RATES: `/rates/market-rates`,
    GET_FIXED_TERM_RATES: `/rates/fixed-term`,

    // Users
    GET_USER_BY_EMAIL: '/users/email/',
    POST_USER: '/users',
    POST_USER_CONFIRM_ACCOUNT: '/users/confirm-account',
    POST_USER_FORGOT_PASSWORD: '/users/forgot-password/',
    POST_USER_RESET_PASSWORD: '/users/reset-password',
};